// Copied from https://github.com/ECFMG/msal-react-lite/tree/f97ae82882ffbc6fbb42405cff5d1f49f0aeda07
import MsalProvider, { MsalProviderPopupConfig, MsalProviderRedirectConfig } from "./msal-provider";
import useMsal from "./use-msal";

export { useMsal };
export type { MsalProviderPopupConfig, MsalProviderRedirectConfig };
export default MsalProvider;
